import React, { useState } from 'react';

import classNames from 'classnames';

import TextButton from 'CommonComponents/TextButton';

import CircleCheckIcon from 'Assets/icons/circle-check.svg';
import XMarkIcon from 'Assets/icons/circle-xmark.svg';

export default function ScoringCriteriaTableEditRow(props) {
    const [mark, setMark] = useState(props.criteria.mark);
    const [description, setDescription] = useState(props.criteria.description);

    const markChange = (e) => {
        setMark(e.target.value);
    };

    const descriptionChange = (e) => {
        setDescription(e.target.value);
    };

    const updateCriteria = () => {
        const data = {
            mark,
            description,
        };

        axios
            .put(props.updateUrl, data)
            .then((response) => {
                props.fetchCriteria();
                $('#criteria-update-toast').toast('show');
            })
            .catch((e) => {
                $('#criteria-update-failed-toast').toast('show');
            });
    };

    return (
        <tr>
            <td className="!tw-bg-white tw-align-top">
                <input type="text" className={classNames('text-input', { invalid: !mark })} value={mark} onChange={markChange} disabled={!props.canEdit} />
            </td>
            <td>
                <textarea
                    className="tw-block tw-w-full tw-rounded-lg tw-text-sm tw-bg-grey/50 tw-p-4 tw-text-charcoal tw-border-none tw-resize-none hover:tw-resize-y"
                    rows={8}
                    value={description}
                    onChange={descriptionChange}
                    disabled={!props.canEdit}
                />
            </td>
            <td>{props.criteria.score}</td>
            <td className="tw-bg-white">
                <div className="tw-flex tw-items-center tw-gap-x-3">
                    <TextButton variant="danger" onClick={() => props.cancelAction()}>
                        <XMarkIcon className="tw-w-3 tw-h-3" />
                        {$t('Cancel')}
                    </TextButton>
                    {!!props.canEdit && (
                        <TextButton variant="primary" onClick={updateCriteria} disabled={!mark}>
                            <CircleCheckIcon className="tw-w-3 tw-h-3" />
                            {$t('Save')}
                        </TextButton>
                    )}
                </div>
            </td>
        </tr>
    );
}
